import React, {useEffect, useState} from 'react';
import {
    AppBar,
    Box,
    createTheme,
    CssBaseline,
    Drawer, GlobalStyles,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ThemeProvider,
    Toolbar,
    Typography
} from '@mui/material';
import {Brightness4, Brightness7, Menu, Scoreboard, Refresh as RefreshIcon} from '@mui/icons-material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import TvIcon from '@mui/icons-material/Tv';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import InfoIcon from '@mui/icons-material/Info';


import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';

import {BrowserRouter as Router, Link, Navigate, Route, Routes, useNavigate} from 'react-router-dom';
import LoginForm from './registration/Login';
import RegistrationForm from './registration/Registration';
import EnterEmail from './registration/Enter_Email';
import RegistrationComplete from './registration/RegistrationComplete';
import Settings from './settings/Settings';

import {useWebSocket} from "./net/WebSocketContext";

import Judging from './judging/Judging';
import Test from './judging/test';
import Skating from './judging/Skating';
import UsersList from './users_list/UsersList';
import Display from './display/Display';
import Results from './results/Results';
import UserProfile from "./profile/UserProfile";
import Sets from "./sets/Sets";
import UsersControl from "./users_control/UsersControl";
import EventsConstructor from "./EventsConstructor";
import AuthHandler from "./registration/AuthHandler";
import ArticlePage from "./faq/boogie_judging";
import Pd from "./pd/pd";
import Pd_Cookie from "./pd/cookie";
import DialogPd from "./common/DialogPd"
import ReactMarkdown from "react-markdown";
import BlurredComponent_all from "./common/BlurredComponent_all";


const App = () => {
    const {ws, latency, config_ui, auth, refresh_config} = useWebSocket();
    const [zoom, setZoom] = useState(1); // Масштаб (1 = 100%)
    const [fullScreen, setFullScreen] = useState(false)
    const [darkMode, setDarkMode] = useState(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [login, setLogin] = useState(true);
    const [tab, setTab] = useState({});
    const [componentKey, setComponentKey] = useState(0); // Для пересоздания компонентов

    useEffect(() => {
        // При изменении tab.value пересоздаем компонент
        if (tab.value) {
            setComponentKey(prev => prev + 1);
        }
    }, [tab.value]);
    const [config_ui_, setConfigUI] = useState(false);
    const [wait_config, setWaitConfig] = useState(false);
    const [eventList, setEventList] = useState([])
    const [private_policy, setPrivatePolicy] = useState(false)
    const [private_policy_db, setPrivatePolicyDB] = useState(false)

    useEffect(() => {
        if(refresh_config) {
            console.log("ON_MESSAGE App", refresh_config)
            getConfigUI()
        }
    }, [refresh_config]);
    useEffect(() => {
        if (config_ui) {
            console.log("ON_MESSAGE App", config_ui)
            if (config_ui?.tabs) {
                setConfigUI(config_ui?.tabs);
            }
            if (config_ui?.PrivatePolicy) {
                setPrivatePolicyDB(config_ui?.PrivatePolicy);
            }
            if (config_ui?.user_id) {
                localStorage.setItem('id', config_ui?.user_id);
            }
        }
    }, [config_ui]);

    useEffect(() => { // Читаем WS
            if (auth?.error === "Unauthorized") {
                //setConfigUI(auth.tabs);
                //console.log("set id:",ws_data?.user_id)
                localStorage.removeItem('token');
                window.location.reload("/")

            }
    }, [auth]);

    // Пишем в WS  action: 'PrivatePolicy',
    useEffect(() => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;}
        const sendPivatePolycy = () =>
        {
            const body={
                action: 'private_policy',
                decision: true
            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:",body)
        }

        if (ws.readyState === WebSocket.OPEN) {
            sendPivatePolycy();
        } else {
            ws.addEventListener("open", sendPivatePolycy);
        }
        return () => {
            ws.removeEventListener("open", sendPivatePolycy);
        };

    },[private_policy]);


    const getConfigUI = () => {

        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;
        }
        const sendOnOpen = () => {
            //setWaitConfig(true)
            ws.zsend(JSON.stringify({action: "config_ui"}));
            console.log("SEND:", {action: "config_ui"});
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }

    useEffect(() => {
        getConfigUI()
    }, [ws]);

    useEffect(() => {
        const checkFullScreen = () => {
            setFullScreen(!!document.fullscreenElement);
        };
        document.addEventListener("fullscreenchange", checkFullScreen);
        return () => {
            document.removeEventListener("fullscreenchange", checkFullScreen);
        };
    }, []);

    // Включение полноэкранного режима
    const enterFullScreen = () => {
        if (fullScreen) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                // Для Safari (iOS)
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                // Для IE
                document.msExitFullscreen();
            }
            setFullScreen(false);
        } else {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen(); // Firefox
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(); // Chrome, Safari
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen(); // IE/Edge
            } else {
                // Если Fullscreen API недоступен (например, iOS Safari)
                alert(
                    "Ваш браузер не поддерживает полноэкранный режим. Попробуйте развернуть вручную."
                );
            }
            setFullScreen(true);
        }
    }
    const theme = createTheme({
        components: {
            MuiLink: {
                styleOverrides: {
                    root: {
                        color: 'rgba(255,165,0,0.76)', // Цвет ссылок
                        textDecoration: 'none', // Без подчеркивания (по желанию)
                        '&:hover': {
                            color: '#1565c0', // Цвет при наведении
                        },
                    },
                },
            },
            MuiTextField: {
                defaultProps: {
                    variant: "filled",  // Устанавливаем variant="filled" для всех TextField
                },
            },
            MuiSelect: {
                defaultProps: {
                    variant: "filled",  // Устанавливаем variant="filled" для всех Select
                },
            },
            MuiFormControl: {
                defaultProps: {
                    variant: "filled",  // Устанавливаем variant="filled" для всех FormControl
                },
            },
            MuiInputLabel: {
                defaultProps: {
                    shrink: true,  // Убираем прерывание лейбла и устанавливаем shrink
                },
            },
            MuiOutlinedInput: {
                defaultProps: {
                    notched: true,  // Для Input с outlined — устанавливаем свойство notched, если необходимо
                },
            },
        },
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: '#FFA500', // Оранжевый цвет
            },
        },
    });

    const globalStyles = (
        <GlobalStyles
            styles={{
                '*::-webkit-scrollbar': {
                    width: '4px',
                    height: '4px',
                    backgroundColor: '#f5f5f5'
                },
                '*::-webkit-scrollbar-track': {
                    backgroundColor: '#575757',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(248,164,1,0.73)'
                },
                '*::-webkit-scrollbar-corner': {
                    backgroundColor: '#555',
                }
            }}
        />
    );

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };
    const handleZoomIn = () => {
        setZoom((prevZoom) => Math.min(prevZoom + 0.1, 2)); // Увеличиваем, но не более 200%
    };
    const handleZoomOut = () => {
        setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5)); // Уменьшаем, но не менее 50%
    };
    const handleZoomDefault = () => {
        setZoom(1); // Уменьшаем, но не менее 50%
    };
    const logOut = () => {
        localStorage.removeItem('token');
        window.location.reload();
    }

    const ButtonList = ({name, value, Icon}) => {
        if(config_ui_?.includes(value)){
            return(
                <ListItem disablePadding key={name}
                          onClick={() => setTab({value: value, name: name})}
                          component={Link} to={"/"+value}>
                    <ListItemButton
                        selected={tab?.value===value}
                    >
                        <ListItemIcon>
                            <Icon/>
                        </ListItemIcon>
                        <ListItemText secondary={name}/>
                    </ListItemButton>
                </ListItem>
            )
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            {globalStyles}
            {/*<BlurredComponent_all isBlurred={(!config_ui)} message={'Подключаемся...'}/>*/}
            {/*TODO Добавить проверку и удаление токена если вышел срок*/}
            {localStorage.getItem('token') ?
                (config_ui_ ?
                    <Router>
                        <Box sx={{
                            display: 'flex',
                            backgroundColor: "transparent",
                            flexDirection: 'column',
                            height: '100vh',
                            overflow: 'hidden'
                        }}>
                            <AppBar
                                position="static"
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    display: '',
                                    backgroundColor: 'transparent'
                                }}
                            >
                                <Toolbar sx={{
                                    display: 'flex',
                                    backgroundColor: 'transparent'
                                }}>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        aria-label="menu"
                                        onClick={toggleDrawer(true)}
                                        sx={{mr: 1}}
                                    >
                                        <Menu/>
                                    </IconButton>
                                    {/* Кнопка обновления текущего компонента */}
                                    {tab.value && (
                                        <IconButton
                                            edge="end"
                                            color="inherit"
                                            onClick={() => setComponentKey(prev => prev + 1)}
                                            sx={{ml: 'auto'}}
                                        >
                                            <RefreshIcon/>
                                        </IconButton>
                                    )}
                                    {/*<Button*/}
                                    {/*    edge="end"*/}
                                    {/*    onClick={vibrate3}*/}
                                    {/*    //sx={{ marginLeft: "auto" }} //*/}
                                    {/*>Посудить</Button>*/}

                                </Toolbar>
                            </AppBar>
                            <Drawer
                                anchor="left"
                                open={drawerOpen}
                                onClose={toggleDrawer(false)}
                                sx={{
                                    '& .MuiDrawer-paper': {
                                        overflow: 'hidden', // Запрет прокрутки меню
                                    },
                                }}
                            >
                                <Box
                                    sx={{width: 250, display: "flex", flexDirection: "column", height: "100%"}}
                                    role="presentation"
                                    onClick={toggleDrawer(false)}
                                    onKeyDown={toggleDrawer(false)}
                                >
                                    <List sx={{flexGrow: 1}}>
                                        <IconButton color="inherit" onClick={toggleDarkMode}>
                                            {darkMode ? <Brightness7/> : <Brightness4/>}
                                        </IconButton>
                                        {tab.value === "judging" &&
                                            <>
                                                <IconButton color="inherit" onClick={enterFullScreen}>
                                                    {!fullScreen ? <FullscreenIcon/> : <CloseFullscreenIcon/>}
                                                </IconButton>
                                                <IconButton onClick={handleZoomIn} color="inherit">
                                                    <ZoomInIcon/>
                                                </IconButton>
                                                <IconButton onClick={handleZoomDefault} color="inherit">
                                                    <ZoomInMapIcon sx={{marginLeft: 0}}/>
                                                </IconButton>
                                                <IconButton onClick={handleZoomOut} color="inherit">
                                                    <ZoomOutIcon sx={{marginLeft: 0}}/>
                                                </IconButton>
                                            </>
                                        }
                                        <IconButton edge="end" sx={{marginLeft: "0px"}}
                                                    onClick={() => setTab({value: "user_profile", name: "Профиль"})}
                                                    component={Link} to={"/user_profile"}>
                                            <PersonIcon/>
                                        </IconButton>
                                        {[
                                            ["Судейство","judging",Scoreboard],
                                            ["Судейство1","skating",Scoreboard],
                                            ["Участники","users_list",GroupsIcon],
                                            ["Как судится BW","how_bw",InfoIcon],
                                            ["Результаты","results",EmojiEventsIcon],
                                            ["Заходы","sets",SettingsIcon],
                                            ["Пользователи","users_control",SettingsIcon],
                                        ].map((item)=>{
                                            return(
                                                <ButtonList key={item[1]} name={item[0]} value={item[1]} Icon={item[2]} />
                                                )
                                        })}
                                        {/*{config_ui?.includes("events_constructor") ?*/}
                                        {/*    <ListItem disablePadding key="Конструктор" onClick={() => setTab({*/}
                                        {/*        value: "events_constructor",*/}
                                        {/*        name: "Конструктор соревнований"*/}
                                        {/*    })} component={Link} to={"/events_constructor"}>*/}
                                        {/*        <ListItemButton>*/}
                                        {/*            <ListItemIcon>*/}
                                        {/*                <EventAvailableIcon/>*/}
                                        {/*            </ListItemIcon>*/}
                                        {/*            <ListItemText secondary="Соревнования"/>*/}
                                        {/*        </ListItemButton>*/}
                                        {/*    </ListItem> : ''}*/}
                                        {/*{config_ui?.includes("events_constructor") ?*/}
                                        {/*    <ListItem disablePadding key="Настройки всего" onClick={() => setTab({*/}
                                        {/*        value: "settings",*/}
                                        {/*        name: "Настройки всего"*/}
                                        {/*    })} component={Link} to={"/settings"}>*/}
                                        {/*        <ListItemButton>*/}
                                        {/*            <ListItemIcon>*/}
                                        {/*                <SettingsIcon/>*/}
                                        {/*            </ListItemIcon>*/}
                                        {/*            <ListItemText secondary="Настройки всего"/>*/}
                                        {/*        </ListItemButton>*/}
                                        {/*    </ListItem> : ""}*/}
                                        {/*<Divider />*/}
                                    </List>
                                    <div style={{
                                        paddingLeft: 10,
                                        fontSize: "8px",
                                        color: "rgb(87,87,87)"
                                    }}>{navigator.userAgent}</div>
                                    <div style={{
                                        // position: "fixed",
                                        // marginLeft: "50px",
                                        paddingLeft: 10,
                                        fontSize: "8px",
                                        color: "rgb(87,87,87)"
                                    }}>latency: {latency.current}</div>
                                    <div style={{
                                        paddingLeft: 10,
                                        fontSize: "8px",
                                        color: "rgb(87,87,87)"
                                    }}>build date: {process.env.REACT_APP_BUILD_DATE}</div>
                                    <div style={{
                                        paddingLeft: 10,
                                        fontSize: "8px",
                                        color: "rgb(87,87,87)"
                                    }}>© 2025 - {new Date().getFullYear()} Sergey Dyakov (MarchD)</div>
                                    <List sx={{justifyContent: "flex-end"}}>
                                        <ListItem disablePadding sx={{mt: "auto"}}>
                                            <ListItemButton onClick={logOut}>
                                                <ListItemIcon>
                                                    <LogoutIcon/>
                                                </ListItemIcon>
                                                <ListItemText secondary="Выход"/>
                                            </ListItemButton>
                                        </ListItem>
                                    </List>
                                </Box>
                            </Drawer>
                            <Box sx={{flex: 1, overflow: 'hidden'}}>
                                <Routes>
                                    <Route path="*" element={<Navigate to="/user_profile"/>}/>
                                    <Route path="/judging" element={<Judging key={componentKey} darkMode={darkMode} zoom={zoom}/>}/>
                                    <Route path="/skating" element={<Skating key={componentKey}/>}/>
                                    <Route path="/users_list" element={<UsersList key={componentKey}/>}/>
                                    <Route path="/scoreboard" element={<Display key={componentKey}/>}/>
                                    <Route path="/how_bw" element={<ArticlePage key={componentKey}/>}/>
                                    <Route path="/pd" element={<Pd key={componentKey}/>}/>
                                    <Route path="/pd_cookie" element={<Pd_Cookie key={componentKey}/>}/>
                                    <Route path="/results" element={<Results key={componentKey}/>}/>
                                    <Route path="/events_constructor" element={<EventsConstructor key={componentKey}/>}/>
                                    <Route path="/user_profile" element={<UserProfile key={componentKey} eventList={eventList}/>}/>
                                    <Route path="/settings" element={<Settings key={componentKey}/>}/>
                                    <Route path="/sets" element={<Sets key={componentKey} setDarkMode={setDarkMode} darkMode={darkMode} />}/>
                                    <Route path="/users_control" element={<UsersControl key={componentKey}/>}/>
                                    <Route path="/RegistrationForm" element={<RegistrationForm key={componentKey}/>}/>
                                    <Route path="/LoginForm" element={<LoginForm key={componentKey}/>}/>
                                    <Route path="/test" element={<Test key={componentKey}/>}/>
                                </Routes>
                            </Box>
                        </Box>
                        {document.location.pathname === "/pd" || document.location.pathname === "/pd_cookie" || private_policy_db ? '':
                        <DialogPd
                            ok={"понимаю и принимаю"}
                            okFn={()=>{setPrivatePolicy(true)}}
                            main_message={"Опа, подъехали формальности..."}
                            message={
                                <ReactMarkdown>
                                    {
`
### Дорогой друг, мы обязаны тебя проинформировать, что в соответствии с действующим законодательством, чтобы всё работало правильно, нужно согласиться с некоторыми формальностями, описанными ниже:
[Положение о порядке обработки, хранения и защиты персональных данных ](/pd)

[Соглашение и использование COOKIE ](/pd_cookie)
### Без этого, увы, никак. Спасибо за понимание!
`
                                    }


                                </ReactMarkdown>
                        }


                            cancel=""
                            cancelFn={
                                ()=>{}
                            }
                        /> }
                    </Router> : '')
                :
                <Box>
                    <IconButton color="inherit" onClick={toggleDarkMode}>
                        {darkMode ? <Brightness7/> : <Brightness4/>}
                    </IconButton>
                    <Router>
                        <Routes>
                            <Route path="*" element={<Navigate to="/"/>}/>
                            <Route path="/" element={<LoginForm/>}/>
                            <Route path="/RegistrationForm" element={<RegistrationForm/>}/>
                            <Route path="/EnterEmail" element={<EnterEmail/>}/>
                            <Route path="/token/:token" element={<AuthHandler/>}/>
                            <Route path="/RegistrationComplete" element={<RegistrationComplete/>}/>
                        </Routes>
                    </Router>
                </Box>
            }
        </ThemeProvider>
    );
};

export default App;